import { ReactNode } from 'react';
import { AnchoredMenu } from '@rossum/components/anchored-menu/AnchoredMenu';
import { Menu } from '@rossum/ui/material';
import { ExportMutationState } from '../annotation-actions/config';
import { ExportMenuContent } from './ExportMenuContent';
import { DownloadFormat } from './formats';

type ExportMenuProps = {
  exportMutationState: ExportMutationState;
  onDownload: (format: DownloadFormat) => void;
  // No `format` — export only, no file download.
  onExport?: (format?: DownloadFormat) => void;
  onAsyncDownload?: () => void;
  selectedItemsCount: number;
  children: (state: { isOpen: boolean }) => ReactNode;
  nested?: boolean;
  onParentClose?: () => void;
  disabled?: boolean;
};

const ExportMenu = ({
  exportMutationState,
  onDownload,
  onExport,
  onAsyncDownload,
  selectedItemsCount,
  children,
  nested,
  onParentClose,
  disabled,
}: ExportMenuProps) => (
  <AnchoredMenu
    nested={nested}
    disabled={disabled}
    renderContent={({
      anchorEl,
      open,
      onClose,
      anchorOrigin,
      transformOrigin,
    }) => {
      const closeAll = () => {
        onClose();
        onParentClose?.();
      };

      return (
        <Menu
          anchorEl={anchorEl}
          open={open}
          onClose={onClose}
          anchorOrigin={anchorOrigin}
          transformOrigin={transformOrigin}
        >
          <ExportMenuContent
            exportMutationState={exportMutationState}
            onDownload={format => {
              onDownload(format);
              closeAll();
            }}
            onExport={
              onExport
                ? format => {
                    onExport(format);
                    closeAll();
                  }
                : undefined
            }
            onAsyncDownload={
              onAsyncDownload
                ? () => {
                    onAsyncDownload();
                    closeAll();
                  }
                : undefined
            }
            selectedItemsCount={selectedItemsCount}
          />
        </Menu>
      );
    }}
  >
    {children}
  </AnchoredMenu>
);

export { ExportMenu };
